import { render, staticRenderFns } from "./GridPage.vue?vue&type=template&id=1ae82d4b&scoped=true&"
import script from "./GridPage.vue?vue&type=script&lang=js&"
export * from "./GridPage.vue?vue&type=script&lang=js&"
import style0 from "./GridPage.vue?vue&type=style&index=0&id=1ae82d4b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae82d4b",
  null
  
)

export default component.exports